import styled, { css } from 'styled-components'
import defaultImg from '/static/images/image-placeholder.png'
import BaseButton from 'components/Button'

export const SkuCard = styled.div`
  height: ${(p) => `${p.adaptiveHeight}px` || '120px'};
  margin: 8px 8px 0;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-radius: 8px;

  background-image: url('${(p) => p.src}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`

export const ovalStyle = css`
  content: ' ';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.color.bgColor};
  position: absolute;
  left: -5px;
`

export const LeftBlock = styled.div`
  width: 0;
  position: relative;
  flex-grow: 1;
  display: flex;
  border-radius: 8px;
  background-image: url(${defaultImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`

export const RightBlock = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0 8px 8px 0;
  position: relative;
  background: ${(p) => p.theme.color.skuCardRightBg};
  padding: 0 8px;
  &:after {
    ${ovalStyle}
    top: -5px;
  }

  &:before {
    content: ' ';
    ${ovalStyle}
    bottom: -5px;
  }
`

export const Countdown = styled.span`
  position: relative;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 500;
  color: ${(p) => p.theme.color.importantColor};
  user-select: none;
`

// TODO: Put this as material button
export const Button = styled(BaseButton)`
  padding: 0;
  user-select: none;
  width: ${(p) => `${p.adaptiveWidth}px`};

  @media ${(p) => p.theme.media.iPhoneSE} {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }

  @media ${(p) => p.theme.media.iPhonePlus} {
    height: 40px;
    line-height: 40px;
  }
`

export const PopularLabel = styled.span`
  font-size: 12px;
  color: #261d06;
  width: 40px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 8px 8px 8px 0;
  background-color: ${(p) => p.theme.color.tagColor};
  user-select: none;
`

export const SomeSpace = styled.span`
  display: block;
  margin-top: ${(p) => `${p.space}px`};
`

export default SkuCard
